import { render, staticRenderFns } from "./EditFlatModal.vue?vue&type=template&id=30ceda38&"
import script from "./EditFlatModal.vue?vue&type=script&lang=js&"
export * from "./EditFlatModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports